import $crypto from '@/utils/crypto'
import { singleDownload } from '@/utils/download'
import * as types from './mutationTypes'
import { Message } from 'element-ui';
import utils from '@/utils/utils'
import { setburyingPointInit } from '../api/system.api'


// * 存储路由数据
export const storageRouteData = function ({ commit }, data) {
  commit(types.SET_ROUTE_INFO, data)
}

// * 预览
export const previewAllFn = async function ({ state }) {
  // 数据埋点
  setburyingPointInit( {
    // 5.预览
    eventType: 5,
    // 1.进入页面
    type: 1
  })

  const {
    id,
    token,
    crmId,
    orgId,
    userId,
    projectId,
    docId,
    createBy,
    docSource,
    loginType,
  } = state.routeInfo
  
  const queryData = {
    id,
    crmId,
    orgId,
    userId,
    projectId,
    docId,
    token,
    createBy,
    loginType,
    docType: 0,
    needRecordRightLog: true,
    sourceType: docSource === 0 ? "projectDoc" : (docSource === 1 ? "manuscriptmanage" : "customfile")
  }

  // 校验文件创建人
  if (createBy !== userId) {
    // 权限判断
    const proPermission = docSource === 0 && !(await utils.checkPreviewPermission(queryData))
    const manustPermission = docSource === 1 && !utils.checkSystemPermission('paper_file_file_preview')
    const customPermission = docSource === 2 && !utils.checkSystemPermission('crm_financing__file_preview')
    if (customPermission || manustPermission || proPermission) {
      Message({
        type: 'error',
        message: '您无文件预览权限！'
      })
      return
    }
  }

  const encodeData = $crypto.encode(JSON.stringify(queryData))
  const wpsPreviewUrl = `/ibsaas-wps-preview/index.html?query=${encodeData}`
  window.open(wpsPreviewUrl, '_blank')
}

// * 下载
export const downloadAllFn = async function ({ state, getters }) {
  const { docSource, rfsId, docName, docId, createBy, userId } = state.routeInfo

  // 校验文件创建人
  if (createBy !== userId) {
    // 权限判断
    const proPermission = docSource === 0 && (await utils.canOperating('download'))
    const manustPermission = docSource === 1 && !utils.checkSystemPermission('paper_file_file_down')
    const customPermission = docSource === 2 && !utils.checkSystemPermission('crm_financing__file_down')
    if (customPermission || manustPermission || proPermission) {
      Message({
        type: 'error',
        message: '您无文件下载权限！'
      })
      return
    }
  }
  
  const paramsData = [
    {
      name: docName,
      id: rfsId,
      docId: docId
    }
  ]
  if (docSource === 8) {
    paramsData[0].url = '/disk/download'
    paramsData[0].rfsId = rfsId
    paramsData[0].source = '8'
    paramsData[0].setSource = 'version'
  }
  singleDownload(paramsData, '/rfs/downloadOuterNet')
}



// WEBPACK FOOTER //
// ./src/store/actions.js